/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Price_Includes_TaxesInputs */

const en_checkout_price_includes_taxes = /** @type {(inputs: Checkout_Price_Includes_TaxesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This total is final and includes all applicable taxes and fees.`)
};

/**
* | output |
* | --- |
* | "This total is final and includes all applicable taxes and fees." |
*
* @param {Checkout_Price_Includes_TaxesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_price_includes_taxes = /** @type {((inputs?: Checkout_Price_Includes_TaxesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Price_Includes_TaxesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_price_includes_taxes(inputs)
});